import {Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {TranslateService} from "@ngx-translate/core";
import {ActivatedRoute, Router} from "@angular/router";
import {Location} from "@angular/common";
// import { WebSocketService } from "../../lib/services/wso2/WebSocketService";
import {AuthenticationService} from "../../lib/services/autenticacion/authentication.service";
import {JwtService} from "../../lib/services/jwt/jwt.service";
import {StorageKeysEnum} from "../../lib/storage/storage-keys.enum";
import {TokenUnlockService} from '../../lib/services/token-unlock/token-unlock.service';
import {RestorePasswordService} from '../../lib/services/restore-password/restore-password.service';
import {AuthService} from "../../lib/services/auth/auth.service";
import {UserUtilsService} from '../../lib/services/user/user-utils.service';
import {Subscription} from 'rxjs';

@Component({
    selector: 'lib-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
    loginForm!: FormGroup;
    @Input() loginFormInput: any;

    showLoginError = false;

    messageError: string = "";

    loading = false;

    @Output() onLoginSuccess: EventEmitter<any> = new EventEmitter<any>();
    @Output() onAuth07Error: EventEmitter<any> = new EventEmitter<any>();

    usernameWso2: string = 'user';
    passwordWso2: string = 'pass';
    samlRequest: string = 'request';
    lastLogOn: string = "";
    fullName: string = "";
    isCurrentLogin: string = "";

    isErrorLogin: boolean = false;

    @ViewChild('wso2form') formWso2: any;

    constructor(
        private formBuilder: FormBuilder,
        private translate: TranslateService,
        private authentication: AuthenticationService,
        private router: Router,
        private route: ActivatedRoute,
        private location: Location,
        private jwtService: JwtService,
        public tokenUnlockService: TokenUnlockService,
        public restorePaswordService: RestorePasswordService,
        private userUtilsService: UserUtilsService
    ) {
    }

    @HostListener('document:keydown.enter', ['$event'])
    handleEnter(event: KeyboardEvent) {
        if (this.loginForm.valid) {
            this.login()
        }
    }

    ngOnInit(): void {
        this.checkReload()
        this.buildForm();
        const sub = this.route.queryParams
            .subscribe(params => {
                if (params["login"] != null) {
                    this.isCurrentLogin = atob(params["login"]);
                }
                if (params["error"] != null) {
                    this.isErrorLogin = true;
                }
            });
        this.subscriptions.push(sub)
        this.location.replaceState("/login");

        if (this.isErrorLogin) {
            this.showLoginError = true;
            this.loading = false;
        }
    }

    buildForm() {
        this.loginForm = this.formBuilder.group({
            username: [this.loginFormInput?.username ? this.loginFormInput?.username : null, [Validators.required]],
            password: [this.loginFormInput?.password ? this.loginFormInput?.password : null, [Validators.required]],
        });
    }

    login(event?: any) {
        this.loading = true;
        // this.authService.removeTokensStorage();
        this.showLoginError = false;
        const sub = this.authentication
            .initLogin(
                this.loginForm.getRawValue().username,
                this.loginForm.getRawValue().password)
            .subscribe({
                next: response => {
                    if (response) {
                        this.lastLogOn = response?.lastLogOn;
                        this.fullName = response?.fullName;
                    }

                    if (response.wso2Login) {
                        this.usernameWso2 = this.loginForm.getRawValue().username;
                        this.passwordWso2 = this.loginForm.getRawValue().password;
                        this.samlRequest = decodeURIComponent(response.samlRequest);
                        setTimeout(() => {
                            this.formWso2.submit()
                        }, 500);
                    } else if (response.jwt != null && response.wsoJwt != null) {
                        this.authentication.login(response, this.onLoginSuccess);
                    } else {
                        this.showLoginError = true;
                        this.messageError =
                            response.detailMessage != "" ? response.detailMessage : null;
                    }
                    this.loading = false;
                },
                error: error => {
                    this.showLoginError = true;
                    this.messageError = '';
                    console.log('Error: ', error);
                    this.clearStorage();
                    this.buildMessageError(error);
                    this.loading = false;
                },
                complete: () => {
                    this.loading = false;
                    this.jwtService.generateKeys();

                    this.userUtilsService.setUserInfoSessionStorage({
                        lastLogOn: this.lastLogOn,
                        fullName: this.fullName
                    })
                }
            });
        this.subscriptions.push(sub)
    }

    subscriptions: Subscription[] = []

    buildMessageError(error: any) {
        if (error && error.errorCode) {
            const errorMessages = {
                AUTH01: 'invalidCredentials',
                AUTH04: 'userAlreadySession',
                AUTH02: "USER_BLOCKED",

            };
            // error.errorCode = "AUTH07"

            if (error.errorCode == "AUTH07") {
                this.onAuth07Error.emit(error.additionalData)
                return
            }

            const errorMessageKey = errorMessages[error.errorCode];
            if (errorMessageKey) {
                this.translate.get(errorMessageKey).subscribe((errorMessage) => {
                    this.messageError = errorMessage;
                });

                if (error.errorCode === 'AUTH02') {
                    this.tokenUnlockService.tokenBlockError = true;
                }
            } else {
                this.handleUnknownError();
            }
        } else {
            this.handleUnknownError();
        }
    }

    handleUnknownError() {
        this.translate.get('unknownError').subscribe((errorMessage) => {
            this.messageError = errorMessage;
        });
    }

    async checkReload() {
        const access = sessionStorage.getItem(StorageKeysEnum.ACCESS_TOKEN)
        const wso = sessionStorage.getItem(StorageKeysEnum.ACCESS_TOKEN_WSO)

        if (access && wso) {
            await this.authentication.logOut()
            return
        }
    }

    clearStorage() {
        sessionStorage.removeItem('ACCESS_TOKEN')
        sessionStorage.removeItem('REFRESH_TOKEN')
        sessionStorage.removeItem('ACCESS_TOKEN_WSO')
        sessionStorage.removeItem('JWT_WSO_DECODE')
        sessionStorage.removeItem('PUBLIC_KEY')
        sessionStorage.removeItem('PRIVATE_KEY')
        sessionStorage.removeItem('USER_INFO')
        sessionStorage.removeItem('CONTRACTS_INFORMATION')
    }

    showFormRestorePassword() {
        this.restorePaswordService.open();
    }

    goToRegisterUsers() {
        this.router.navigate(['/users/register'])
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(sub => sub.unsubscribe())
    }
}
